import { faHeart } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UnitCount from '../../../../Abstracts/UnitCount/UnitCount';
import { useUser } from '../../../../Context/UserContext';
import style from './Favourites.module.scss?module';
import UserLoginPopUp from '../../../../Abstracts/Modals/UserLoginPopUp/UserLoginPopUp';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Favourites = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const { user } = useUser();
  const navigate = useNavigate();

  const navigateToFavourites = () => {
    if (!user?.id) {
      setShowLoginPopup(true);
    } else {
      navigate('/products?view=grid&favs_only=1');
    }
  };

  return (
    <>
      <UserLoginPopUp
        showLoginPopup={showLoginPopup}
        setShowLoginPopup={setShowLoginPopup}
        onLoginSuccess={() => {
          setShowLoginPopup(false);
          navigate('/products?view=grid&favs_only=1');
        }}
      />
      <button
        type="button"
        className={[style.favourites].join(' ')}
        onClick={navigateToFavourites}
      >
        <div className="position-relative d-flex justify-content-center">
          <FontAwesomeIcon className={style.iconLinkIcon} icon={faHeart} />
          <UnitCount value={user?.favourites_count} />
        </div>
      </button>
    </>
  );
};

export default Favourites;
